<template>
  <div v-if="total > 0" class="fdd-page">
    <div class="page-sum">共{{ getPageCount }}页/总计{{ total }}条数据</div>
    <div class="page-list">
      <a class="use-left" :class="{ 'page-no': firstMark }" @click="prev()"></a>
      <!-- 按新的 UI 组件规范，分页只保留当前页，因此注释其他代码 -->
      <a style="cursor: default;" class="page-hover">{{ currentPage }}</a>
      <a class="use-right" :class="{ 'page-no': endMark }" @click="next()"></a>
    </div>
    <div class="fdd-select">
      <fdd-select v-model="pageSize" :top="-150" @change="handlePageSizeChange">
        <fdd-option v-for="(item, index) in getPageSizeList" :key="index" :value="item">{{ item }}条/页</fdd-option>
      </fdd-select>
    </div>
    <div class="page-go">
      前进
      <input v-model.trim="currentPageValue" type="text" @change="paging(currentPageValue)" />
      页
    </div>
  </div>
</template>
<script>
  export default {
    name: 'Page',
    props: {
      current: {
        type: [Number, String],
        default: 1
      },
      size: {
        type: Number
      },
      total: {
        type: [Number, String],
        default: 0
      },
      totalPageCount: {
        type: Number,
        default: 0
      },
      pageType: {
        type: Number,
        default: 1
      },
      paged: {
        type: Function
      }
    },

    data() {
      return {
        pageSizeList: [10, 20, 50, 100, 200],
        pageSize: 10,
        pageCount: 0,
        currentPage: 1,
        pageSizeBox: false,
        currentPageValue: 1
      }
    },

    computed: {
      getPageSizeList() {
        return this.pageSizeList
      },
      show() {
        return this.getPageCount > 0
      },
      firstMark() {
        return this.currentPage === 1
      },
      endMark() {
        return this.currentPage === this.getPageCount
      },
      getPageCount() {
        if (this.totalPageCount) {
          return this.totalPageCount
        } else {
          return Math.ceil(this.total / this.pageSize)
        }
      }
    },

    watch: {
      current(page) {
        this.currentPage = Number(page)
      },
      currentPage(value) {
        this.currentPageValue = Number(value)
      }
    },

    created() {
      if (this.size) {
        this.pageSize = this.size
      }
    },

    methods: {
      prev() {
        this.currentPage--
        if (this.currentPage < 1) {
          this.currentPage = 1
        } else {
          this.paged.call(this, this.currentPage, this.pageSize)
        }
      },
      next() {
        this.currentPage++
        if (this.currentPage > this.getPageCount) {
          this.currentPage = this.getPageCount
        } else {
          this.paged.call(this, this.currentPage, this.pageSize)
        }
      },
      paging(pageNo) {
        if (pageNo > this.getPageCount) {
          pageNo = this.getPageCount
        }
        if (!pageNo || pageNo < 1) {
          pageNo = 1
        }
        this.currentPage = pageNo
        this.paged.call(this, this.currentPage, this.pageSize)
      },
      handlePageSizeChange() {
        this.paging(this.currentPage)
      }
    }
  }
</script>
